import { COLORS } from "./constants";
import type { CandleWithFlag } from "./types";

export function drawCandles(
  ctx: CanvasRenderingContext2D,
  dataArr: CandleWithFlag[],
  startIndex: number,
  visibleCount: number,
  left: number,
  candleWidth: number,
  candleBodyWidth: number,
  priceToY: (price: number) => number,
  animatedValues: Map<number, { close: number; high: number; low: number }>,
) {
  for (let i = 0; i < visibleCount; i++) {
    const dataIndex = startIndex + i;
    if (dataIndex >= dataArr.length) continue;

    const candle = dataArr[dataIndex];
    if (!candle || !("open" in candle) || !("close" in candle)) continue;

    const isUp = candle.close >= candle.open;
    const x = left + (i + 0.5) * candleWidth;

    let closePrice = candle.close;
    let highPrice = candle.high;
    let lowPrice = candle.low;

    const animated = animatedValues.get(dataIndex);
    if (animated) {
      closePrice = animated.close;
      highPrice = animated.high;
      lowPrice = animated.low;
    }

    ctx.beginPath();
    ctx.moveTo(x, priceToY(highPrice));
    ctx.lineTo(x, priceToY(lowPrice));
    ctx.strokeStyle = isUp ? COLORS.upBorder : COLORS.downBorder;
    ctx.lineWidth = 1;
    ctx.stroke();

    const yOpen = priceToY(candle.open);
    const yClose = priceToY(closePrice);
    const bodyTop = Math.min(yOpen, yClose);
    const bodyHeight = Math.max(1, Math.abs(yClose - yOpen));

    ctx.fillStyle = isUp ? COLORS.up : COLORS.down;
    ctx.fillRect(x - candleBodyWidth / 2, bodyTop, candleBodyWidth, bodyHeight);

    if (candleWidth > 3) {
      ctx.strokeStyle = isUp ? COLORS.upBorder : COLORS.downBorder;
      ctx.strokeRect(x - candleBodyWidth / 2, bodyTop, candleBodyWidth, bodyHeight);
    }
  }
}
